module.exports = __webpack_public_path__ + "static/media/down_arrow.07870b23.svg";